//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import Preloader from './Preloader.vue';
export default {
        components:{
            Preloader
        },
    props: {
        loading: Boolean,
    },
    computed: {
        isLoading() {
            console.log(this.loading);
            return this.loading;
        },
    },
};
